@if (content$() | async; as content) {
  <div class="arrow-link-list flex flex--column gr-large">
    @if (content.teaserTitle) {
      <fcom-heading-tag
        [level]="headerLevel(content.subjectTaxonomyTags || []) ?? DEFAULT_HEADER_LEVEL"
        [extraClasses]="headerFontLevel(content.subjectTaxonomyTags || []) ?? 'font-heading-3 font-headline-small'"
        >{{ content.teaserTitle }}</fcom-heading-tag
      >
    }

    @for (item of content.items; track item.contentId) {
      <fin-text-link-left
        [target$]="
          item.contentType === CmsContentType.CMExternalLink
            ? (item | finToObservable)
            : (item.target | finToObservable)
        "
        [teaserTitle$]="item.teaserTitle | finToObservable"
      />
    }
  </div>
}
